function DriversViewIframeController(config, $scope, $sce) {
  const ctrl = this;

  ctrl.$onInit = () => {
    $scope.driversViewURL = $sce.trustAsResourceUrl(config.driversViewURL);
  };

  ctrl.$onDestroy = () => {};
}

angular
  .module('gridlets.module')
  .controller('DriversViewIframeController', DriversViewIframeController);